import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/RichTextBox' /* webpackChunkName: "RichTextBox" */),
    import(
      './viewer/RichTextBox.controller' /* webpackChunkName: "RichTextBox" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('RichTextBox', UiTypes),
};

export default entry;
